import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import _ from 'lodash';
import { observable, autorun, action, toJS } from 'mobx';
import { observer } from 'mobx-react'

import {DictionaryTrans,autobind} from './DictionaryTrans';
import reactMixin  from 'react-mixin';
import Picker from './Picker';
import SpectrumPicker from './SpectrumPicker';
import userSettings from './UserSettings';

@observer
@reactMixin.decorate(DictionaryTrans)
@reactMixin.decorate(autobind(Object.keys(DictionaryTrans)))
export default class ToolbarBackground extends Component{

  @observable trans = {  };
  @observable showSpectrumPicker = false;

  constructor(props) {

    super(props);
    this.trans = this.props.dictionaryStorage.getCurrentLangDict;
  }

  onChoiceColor(color){

    $(window).trigger('BackgroundColor-setBackgroundColor', '#'+color);
  }

  showPickArea(){
    this.showSpectrumPicker = !this.showSpectrumPicker;
  }

  addColor(color){

    userSettings.addColor(color);
    this.showSpectrumPicker = !this.showSpectrumPicker;
  }

  render() {

    const t = this.t;

    return (
      <div className="ToolbarBackground">
        <h6 className="Toolbar-title"><span>{t('Background')}</span></h6>
        <div className="Toolbar-body">

          {
            !this.showSpectrumPicker
            ?

              <Picker
                bodyMode={true}
                showPickArea={ ()=> { this.showPickArea() } }
                dictionaryStorage={this.props.dictionaryStorage}
                onChoiceColor={  (color)=> { this.onChoiceColor(color) } }
                onClickOutside={ ()=> {  } }
              >
              </Picker>

              :

              <SpectrumPicker
                dictionaryStorage={this.props.dictionaryStorage}
                addColor={ (color)=> { this.addColor(color) } }
                closePickArea = { ()=> { this.showPickArea() } }
                disablePickerMode = { ()=> { this.isPipetteMode = false} }
                enablePickerMode = { ()=> { this.isPipetteMode = true} }
              ></SpectrumPicker>
          }

        </div>

      </div>
    );

  }
}


